import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IReminderSetRequest, IReminderSetResponse } from '../../../entity/interface/iReminder';
import { IReminderRepository } from '../../repositories/interfaces/iReminderRepository';

export interface ISetReminderUseCase {
    execute(
        apikey: string,
        payload: IReminderSetRequest,
        token: string,
        identityToken: string,
        lang: string,
        type: string
    ): Promise<IReminderSetResponse>;
}
export class SetReminderUseCase implements ISetReminderUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get setReminder(): IReminderRepository {
        return container.resolve<IReminderRepository>(DI.REPOSITORIES.IReminderRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apikey: string,
        payload: IReminderSetRequest,
        token: string,
        identityToken: string,
        lang: string,
        type: string
    ): Promise<IReminderSetResponse> {
        return await this.setReminder.setReminder(apikey, payload, token, identityToken, lang, type);
    }
}
